import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

// Move selector outside component to maintain memoization
const profiledropdownData = createSelector(
    (state : any) => state.Profile,
    (profile) => ({
        user: profile.user
    })
);

const getDisplayName = (record : any): string | undefined => {
    if (!record || typeof record !== 'object') {
        return undefined;
    }
    if (record.fullName) {
        return record.fullName;
    }
    if (record.username) {
        return record.username;
    }
    if (record.name) {
        return record.name;
    }
    if (record.first_name && record.last_name) {
        return `${record.first_name} ${record.last_name}`.trim();
    }
    if (record.first_name) {
        return record.first_name;
    }
    if (record.data) {
        return getDisplayName(record.data);
    }
    if (record.user) {
        return getDisplayName(record.user);
    }
    return undefined;
};

const getAvatarUrl = (record: any): string | undefined => {
    if (!record || typeof record !== 'object') {
        return undefined;
    }
    if (record.avatar) {
        return record.avatar;
    }
    if (record.profileImage) {
        return record.profileImage;
    }
    if (record.image) {
        return record.image;
    }
    if (record.data) {
        return getAvatarUrl(record.data);
    }
    if (record.user) {
        return getAvatarUrl(record.user);
    }
    return undefined;
};

const ProfileDropdown = () => {
    // Inside your component
    const { user } = useSelector(profiledropdownData);

    const [userName, setUserName] = useState("Admin");
    const [userAvatar, setUserAvatar] = useState<string | undefined>(undefined);

    useEffect(() => {
        const authUser = sessionStorage.getItem("authUser");
        console.log("user: ", user);
        let derivedName: string | undefined = getDisplayName(user);
        let derivedAvatar: string | undefined = getAvatarUrl(user);
        if (authUser) {
            try {
                const parsed = JSON.parse(authUser);
                const sessionName = getDisplayName(parsed) || parsed.email;
                derivedName = sessionName || derivedName;
                derivedAvatar = getAvatarUrl(parsed) || derivedAvatar;
            } catch (error) {
                derivedName = derivedName || undefined;
            }
        }
        if (!derivedName && process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const firebaseUser = (user as any)?.multiFactor?.user;
            derivedName = firebaseUser?.displayName || firebaseUser?.email;
            derivedAvatar = firebaseUser?.photoURL || derivedAvatar;
        }
        setUserName(derivedName || "Admin");
        setUserAvatar(derivedAvatar);
    }, [user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState<boolean>(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {userAvatar ? (
                            <img className="rounded-circle header-profile-user" src={userAvatar} alt="Header Avatar" />
                        ) : (
                            <span className="rounded-circle header-profile-user bg-secondary-subtle text-secondary d-inline-flex align-items-center justify-content-center">
                                {(userName || 'A').trim().charAt(0).toUpperCase() || 'A'}
                            </span>
                        )}
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/profile" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/pages-faqs" className="dropdown-item">
                            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Help</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem
                        onClick={() => {
                            if ((window as any).restartOnboardingTour) {
                                (window as any).restartOnboardingTour();
                            }
                        }}
                    >
                        <i className="mdi mdi-map-marker-path text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Getting Started Tour</span>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
